<template>
    <div>
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                    <el-select v-model="formData.ckname" placeholder="请选择委托公司" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="one in wtgsList"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="jgname" label="加工公司" >
                    <el-input  v-model="formData.jgname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="bmname" label="车间部门" >
                    <el-input  v-model="formData.bmname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>

            </div>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                    <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')" filterable required clearable disabled>
                        <el-option
                                v-for="one in warehouseList"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="sqName" label="申请人" >
                    <el-input  v-model="formData.sqName" disabled>
                    </el-input>
                </el-form-item>
            </div>
            <div style="margin-bottom: 20px">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="tableData"
                          height="504"
                          size="mini"
                          :key="tableId"
                          :row-class-name="tableRowClassName"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_jgname"
                            :label="$t('form_goods_rights_company')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column
                             align="left"
                             prop="vc_no"
                             label="批次号"
                    width="200"
                             show-overflow-tooltip>
                     </el-table-column>-->
                    <el-table-column
                            v-if="i_id!=0"
                            align="left"
                            prop="f_innum"
                            label="投料数量"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="kcsl"
                            :label="$t('form_inventory_quantity')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id==0"
                            align="left"
                            prop="f_innum"
                            label="投料数量"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_innum'" :rules="formRules.f_num">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_innum" @change="tlChange(scope.row,scope.$index)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id==0"
                            align="left"
                            prop="f_innum_zb"
                            label="折百量"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_innum_zb'" :rules="formRules.f_innum_zb">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_innum_zb"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id!=0"
                            align="left"
                            prop="f_innum_zb"
                            label="折百量"
                            width="110">
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="i_id==0">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1200"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" label="当班日志" >
                <el-input  v-model="formData.vc_note" :disabled="chakan">
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" label="录入时间" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center" v-if="!chakan">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">保存</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
            <!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    export default {
        name: "ReceiveForm",
        components: {ProductDetails},
        props:{
            receive:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                formData:{
                    jgname:"",
                    wtname:"",
                    ckname:"",
                    sqname:"",
                    bmname:"",
                    vc_note:"",
                    num:"000000",
                    vc_lruname:sessionStorage.getItem("lruname"),
                    date:"",
                    tableData:[],
                },
                wtgsList:[],
                warehouseList:[],
                formRules:{
                },
                tableData:[],
                visible:false,
                isbtn:false,
                productDetails:{},
                disabled:false,
                edit:false,
                chakan:false,
                i_pid:0,
                i_id:0,//新增
                state:0,
                i_rwid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                editForm:{},
                date:'',
                tableId:0,
                mid:0,
            }
        },
        watch: {
            receive: {
                handler() {
                    if (this.receive) {

                        this.pageSize=this.page_size;
                        this.i_id=this.receive.i_id;
                        if (this.receive.i_id==0){
                            this.getDateYYYYMMddHHMMSS();
                            this.form=this.receive.taskDa;
                            // console.log("this.form",this.form)
                            this.productDetails=this.receive.taskDa;
                            this.edit=false;
                            this.chakan=false;
                            this.formData={
                                jgname:this.form.vc_gsname,
                                wtname:this.form.vc_ingsname,
                                tldate:this.date,
                                date:this.date,
                                bmname:this.form.vc_cjname,
                                num:"000000",
                                vc_note:'',
                                vc_lruname:sessionStorage.getItem("lruname"),
                                tableData:[],
                            };
                            /*this.tableData=[
                                {vc_jgname:"1",f_innum:2.35,f_innum_zb:2.35},
                                {vc_jgname:"13",f_innum:2.63,f_innum_zb:2.35},
                                {vc_jgname:"12",f_innum:245.3,f_innum_zb:2.35},
                                {vc_jgname:"e1",f_innum:2.543,f_innum_zb:2.35},
                                {vc_jgname:"r1",f_innum:2.363,f_innum_zb:2.35},],*/

                            // console.log( "this.receive",this.formData);
                        }else {
                            if (this.receive.title=="在线退回"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }
                            //    编辑

                            this.edit=true;
                            this.isbtn=true;
                            this.editForm=this.receive.value;
                            this.form=this.receive.taskDa;
                            // this.getFeedingDetails();
                        }
                        // console.log(this.receive, "this.receive",this.editForm);
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
        this.baseerp=baseerp;
        },
        methods: {
            popShow(){
                this.visible=true
                //console.log(this.visible)
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                /*let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] ? '' : hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] = true && item.push(next);
                    return item
                }, []);*/
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            tlChange(val,index){
                if (this.tableData[index].kcsl<val.f_innum){
                    this.$message.error("投料不得大于库存量")
                    this.tableData[index].f_innum=this.tableData[index].kcsl;
                }
                this.tableData[index].f_innum_zb=this.tableData[index].f_innum;
                // this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].kcsl,this.tableData[index].f_innum);
                this.tableId=Math.random();
            },
            //保存
            async saveForm(){
                let details = this.tableData.filter(item=>item.f_innum!=0);
                if (details.length==0){
                    this.$message.error("请添加产品");
                    return ;
                }
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_rwid:this.form.i_id,
                    i_gsid:this.form.i_gsid,
                    i_cjid:this.form.i_cjid,
                    i_ckid:this.form.i_ckid,
                    i_pzid:this.form.i_pzid,
                    i_lruid:sessionStorage.getItem("userid"),
                    vc_lruname:sessionStorage.getItem("lruname"),
                    vc_note:this.formData.vc_note,
                    details:details,
                };
                let res=await API.saveFeeding(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.disabled=true;
                    this.visible=false;
                    this.$emit('getConsumeList',this.pageSize)
                    // this.$emit('addLine',this.pageSize)
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
    /deep/{
        .danger-row{
            color: #999;
        }
        .el-table__footer-wrapper {
            position: absolute !important;
            bottom: 0;
        }
    }
</style>